import {useState} from 'react';
import {Trans} from '@ui/i18n/trans';
import {Product} from '../product';
import {CheckIcon} from '@ui/icons/material/Check';

interface FeatureListProps {
  product: Product;
}

const DEFAULT_SUBSCRIPTION_FEATURES = [
  'No advertisements',
  'Watch from anywhere',
  'On any device',
  'Cancel anytime',
];

const DEFAULT_FREE_FEATURES = [
  'Access to free content',
  'No credit card required',
  'Cancel anytime',
];

export function ProductFeatureList({product}: FeatureListProps) {
  const [isMobileFeatureListOpen, setIsMobileFeatureListOpen] = useState(false);
  const features = product.feature_list.length
    ? product.feature_list
    : product.free
      ? DEFAULT_FREE_FEATURES
      : DEFAULT_SUBSCRIPTION_FEATURES;

  return (
    <>
      <details
        className="group mt-24 border-t pt-20 md:hidden"
        open={isMobileFeatureListOpen}
        onToggle={event =>
          setIsMobileFeatureListOpen(event.currentTarget.open)
        }
      >
        <summary className="cursor-pointer text-sm font-semibold marker:text-primary">
          <Trans message="What's included" />{' '}
          <span>({isMobileFeatureListOpen ? 'ler menos' : 'ler mais'})</span>
        </summary>
        <div className="mt-8">
          <FeatureItems features={features} />
        </div>
      </details>
      <div className="mt-24 hidden border-t pt-20 md:mt-32 md:block md:pt-24">
        <div className="mb-8 text-sm font-semibold md:mb-10">
          <Trans message="What's included" />
        </div>
        <FeatureItems features={features} />
      </div>
    </>
  );
}

function FeatureItems({features}: {features: string[]}) {
  return (
    <>
      {features.map(feature => (
        <div
          key={feature}
          className="flex items-start gap-10 py-5 text-sm leading-6 md:items-center md:py-6 md:leading-normal"
        >
          <CheckIcon
            className="mt-2 flex-shrink-0 text-primary md:mt-0"
            size="sm"
          />
          <span>
            <Trans message={feature} />
          </span>
        </div>
      ))}
    </>
  );
}
